import { render, staticRenderFns } from "./AnnotationCardReply.vue?vue&type=template&id=4cb8f9cf&scoped=true&"
import script from "./AnnotationCardReply.vue?vue&type=script&lang=js&"
export * from "./AnnotationCardReply.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationCardReply.vue?vue&type=style&index=0&id=4cb8f9cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb8f9cf",
  null
  
)

export default component.exports